import moment from 'moment';

/**
 *
 * 두 시작/종료시간을 받아 얼마나 재생했는지 표시
 * @function
 * @param {String} 12:00, 13:00 or 1200, 1300
 * @returns {String} 핫이슈 날자계산 되어 나오는 부분
 * 자료형 "content_date": "2021-10-19T18:40:00.000Z"
 */
export const toContentDate = (contentDate) => {
  const toDay = moment(); // 현재날자
  const contentDateMoment = moment(contentDate);
  // moment().subtract(7, 'days');
  //   시간표시 : 00분, 00시간, 00일, 0주 (59초 이하 1분으로 표시)
  const reYear = moment.duration(toDay.diff(contentDateMoment)).years();
  const reMonth = moment.duration(toDay.diff(contentDateMoment)).months();
  const reDay = moment.duration(toDay.diff(contentDateMoment)).days();
  const reHours = moment.duration(toDay.diff(contentDateMoment)).hours();
  const reMinutes = moment.duration(toDay.diff(contentDateMoment)).minutes();

  let result = '';

  // 현재 시간 기준으로 년, 월, 주, 일, 시간, 분 차이 계산
  if (reYear >= 1) {
    result = reYear + '년전';
  } else if (reMonth >= 1) {
    result = reMonth + '달전';
  } else if (reDay >= 1) {
    result = reDay + '일전';
  } else if (reHours >= 1) {
    result = reHours + '시간전';
  } else if (reMinutes >= 1) {
    result = reMinutes + '분전';
  }

  return result;
};

function pad (num) {
  return ('0' + num).slice(-2);
}

export const toConvertPlayerTime = (contentDate) => {
  let minutes = Math.floor(contentDate / 60);
  const sec = contentDate % 60;
  minutes = minutes % 60;
  const result = pad(minutes) + ':' + pad(sec);
  return result;
};

export const toStringByDateFormat = (date, delimiter = '-') => {
  const year = date.getFullYear();
  const month = pad(date.getMonth() + 1);
  const day = pad(date.getDate());

  return [year, month, day].join(delimiter);
}